import { render, staticRenderFns } from "./ModalErroProduto.vue?vue&type=template&id=71727aa5&"
import script from "./ModalErroProduto.vue?vue&type=script&lang=js&"
export * from "./ModalErroProduto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports